/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoicingMode = {
    Direct: 'DIRECT',
    Subcontracting: 'SUBCONTRACTING',
    Tripartite: 'TRIPARTITE'
} as const;
export type InvoicingMode = typeof InvoicingMode[keyof typeof InvoicingMode];


export function instanceOfInvoicingMode(value: any): boolean {
    for (const key in InvoicingMode) {
        if (Object.prototype.hasOwnProperty.call(InvoicingMode, key)) {
            // @ts-ignore
            if (InvoicingMode[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoicingModeFromJSON(json: any): InvoicingMode {
    return InvoicingModeFromJSONTyped(json, false);
}

export function InvoicingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicingMode {
    return json as InvoicingMode;
}

export function InvoicingModeToJSON(value?: InvoicingMode | null): any {
    return value as any;
}

